import React from "react";

import { BillRows } from "@Modules/common/BillRows";

import { classNames } from "repoV2/utils/common/render/classNames";
import { IPaymentSummary } from "../../IPaymentSummary";

import styles from "./ExpandedBill.module.scss";
import useExpandedBillRowData from "../../utils/useExpandedBillRowData";
import ExpandCollapseButton from "../ExpandCollapseButton/ExpandCollapseButton";
import commonStyles from "../../../commonStyles.module.scss";

const ExpandedBill = (
    props: IPaymentSummary.IExpandedBillProps
): JSX.Element => {
    const {
        billRowsData,
        isMerchandise,
        shippingText,
        toggleIsPaymentSummaryExpanded,
        isPaymentSummaryExpanded,
    } = useExpandedBillRowData(props);

    const { isMobile } = props;

    return (
        <div className="w-100">
            <div
                className={classNames(
                    "d-flex justify-content-between",
                    commonStyles.sidebarSectionTitle
                )}
            >
                <div>Payment Summary</div>
                <ExpandCollapseButton
                    expandDirection={!isMobile ? "down" : "up"}
                    expanded={isPaymentSummaryExpanded}
                    toggleState={toggleIsPaymentSummaryExpanded}
                    text="close"
                />
            </div>
            <BillRows billRowsData={billRowsData} styles={styles} />
            {isMerchandise ? (
                <div className={styles.sidebarInfo}>{shippingText}</div>
            ) : null}
        </div>
    );
};

export default ExpandedBill;
